import React from 'react';
import { DropDown } from '../../../../common/dropdown';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeDerivative } from './../../reducer';

const mapStateToProps = state => {
  return {
    currentDerivative: state[REDUCER_NAME].currentDerivative,
    listDerivative: state[REDUCER_NAME].listDerivative,
    listDerivativeByKey: state[REDUCER_NAME].listDerivativeByKey,
    watchListId: state[REDUCER_NAME].watchListId,
  };
};

const mapDispatchToProps = {
  changeDerivative,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterDerivative);

function FilterDerivative(props) {
  return (
    <DropDown
      id={props.watchListId}
      keyTitle="name"
      listKey={props.listDerivative}
      listDataByKey={props.listDerivativeByKey}
      currentKey={props.currentDerivative}
      change={props.changeDerivative}
      isI18n={true}
    />
  );
}
